export function localeSort<T>(arr: T[], getComparable: (a: T) => string): T[] {
  const sortedArr = [...arr];
  return sortedArr.sort((a, b) => getComparable(a).localeCompare(getComparable(b)));
}
